import React, { useEffect } from "react";
import { useWebSession } from "@switch/core";

export const ResultProcessor= ({ result , onProcessed}) => {
    const { session, SetPayResult } = useWebSession()
    useEffect(() => {
        SetPayResult(result)
    }, [result])

    
    if (session?.payResultData === JSON.stringify(result)) onProcessed(true)

    return;

}